exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".responseModal .responseWrap{position:relative}@media(min-width:1025px){.responseModal .activityBox{padding-left:80px}}.responseModal .evaluationBox{position:absolute;top:0;right:5px}.responseModal .evaluationTags{display:block;margin:0 80px}.responseModal .studentInfoContainer{margin-bottom:20px;margin-right:100px}@media(min-width:1025px){.responseModal .studentInfoContainer{margin-left:80px}}@media(min-width:1025px){.responseModal .commentBox{margin:0 80px}}@media(max-width:1024px){.responseModal .commentBox{margin-left:10px}}.responseModal .editResponse{float:right;cursor:pointer}@media(min-width:1025px){.responseModal .editResponse{margin-right:80px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/responses/response_modal.scss
// module id = 920
// module chunks = 0